module.exports = __webpack_public_path__ + "static/media/broken.f49c39bb.png";